// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { PageContent } from '@/components/page-content';
import { TriageListing } from '@/items/components/triage-listing';
import {
  TriageSearchListing,
  getTriageStatusFromSearch,
  triageSearchListingSchema,
} from '@/items/hooks/use-triage-items';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Route configuration for item triage listing page.
 * Default filter (no status param) shows items needing review.
 */
export const Route = createFileRoute('/_app/integrations/triage/items')({
  component: ItemTriageRoute,
  validateSearch: triageSearchListingSchema,
});

/**
 * Main component for the item triage listing page.
 */
function ItemTriageRoute() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  const searchParameters: TriageSearchListing = {
    status: search.status,
  };

  // Get the current status, defaulting to NEEDS_REVIEW when no param
  const currentStatus = getTriageStatusFromSearch(search.status);

  return (
    <PageContent>
      <TriageListing
        currentStatus={currentStatus}
        searchParameters={searchParameters}
        navigateFn={navigate}
      />
    </PageContent>
  );
}
